import React from 'react';
import PT from 'prop-types';
import { Icon, Dropdown } from 'semantic-ui-react';
import classes from './yearDropdown.css';

const AngleIcon = () => (
  <Icon fitted name="angle down" className={classes.angleDown} />
);

const YearDropdown = ({ selectedYear, years, onChangeYear }) => (
  <Dropdown
    id="years"
    className={classes.yearDropdown}
    value={selectedYear}
    options={years}
    onChange={onChangeYear}
    icon={<AngleIcon />}
  />
);

YearDropdown.propTypes = {
  selectedYear: PT.number.isRequired,
  years: PT.arrayOf(PT.shape({
    key: PT.number,
    value: PT.number,
    text: PT.string,
  })).isRequired,
  onChangeYear: PT.func.isRequired,
};

export default YearDropdown;



// WEBPACK FOOTER //
// ./src/app/components/FilterComponents/YearDropdown.js